// extracted by mini-css-extract-plugin
export var fileUpload = "_g1-1";
export var modalButton = "_g1-0";